export default "__VITE_ASSET__CkUHkmxU__"